import React from 'react';
import { encodeQueryParams } from 'src/api/client';
import { StyledLink } from 'src/common';
import { ColorSet } from 'src/redux/reducers/theme';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

interface TLLinkProps {
  children: React.ReactNode;
  date?: string | null;
  newPage?: boolean;
  isPast?: boolean;
  colorOverride?: keyof ColorSet;
}

export const TLLink: React.FC<TLLinkProps> = ({ children, date, newPage, isPast, colorOverride }) => {
  if (!date) return <>{children}</>;

  return (
    <StyledLink
      $color={colorOverride || (isPast ? 'statusRed' : 'prussianBlue')}
      to={`/timeline${encodeQueryParams({ date })}`}
      target={newPage ? '_blank' : undefined}
      onClick={() =>
        mpEvent(MPEvents.DateToTimelineLink, {
          date: date!,
        })
      }
    >
      {children}
    </StyledLink>
  );
};
